var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"private-inner"},[_c('private-header',{attrs:{"user":_vm.user}}),_c('private-menu',{attrs:{"user":_vm.user}}),_c('v-main',{staticClass:"content"},[_c('router-view',{attrs:{"user":_vm.user}}),_c('linked-content-popin'),_c('push-popin'),_c('snackbar')],1),_c('private-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }